import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  FaUsers,
  FaExchangeAlt,
  FaCheckCircle,
  FaWallet,
  FaChartLine
} from "react-icons/fa";

const Dashboard = () => {

  // =========================
  // STATES
  // =========================

  const [totalUsers, setTotalUsers] =
    useState(0);

  const [activeTrades, setActiveTrades] =
    useState(0);

  const [closeTrades, setCloseTrades] =
    useState(0);

  const [todayProfit, setTodayProfit] =
    useState(0);

  const [totalDeposit, setTotalDeposit] =
    useState(0);

  const [recentTrades, setRecentTrades] =
    useState([]);

  // =========================
  // TOTAL USERS
  // =========================

  const fetchTotalUsers =
    async () => {

      try {

        const res =
          await axios.get(
            "https://api.statixtrading.in/api/dashboard-total-users"
          );

        if (res.data.success) {

          setTotalUsers(
            res.data.total_users
          );

        }

      } catch (error) {

        console.log(error);

      }

    };

  // =========================
  // ACTIVE TRADES
  // =========================

  const fetchActiveTrades =
    async () => {

      try {

        const res =
          await axios.get(
            "https://api.statixtrading.in/api/dashboard-active-trades"
          );

        if (res.data.success) {

          setActiveTrades(
            res.data.active_trades
          );

        }

      } catch (error) {

        console.log(error);

      }

    };


  const fetchCloseTrades =
    async () => {

      try {

        const res =
          await axios.get(
            "https://api.statixtrading.in/api/dashboard-closed-trades"
          );

        if (res.data.success) {

          setCloseTrades(
            res.data.closed_trades
          );

        }

      } catch (error) {

        console.log(error);

      }

    };



  const fetchTodayProfit =
    async () => {

      try {

        const res =
          await axios.get(
            "https://api.statixtrading.in/api/dashboard-today-profit"
          );

        if (res.data.success) {

          setTodayProfit(
            res.data.today_profit
          );

        }

      } catch (error) {

        console.log(error);

      }

    };

  // =========================
  // TOTAL DEPOSIT
  // =========================

  const fetchTotalDeposit =
    async () => {

      try {

        const res =
          await axios.get(
            "https://api.statixtrading.in/api/dashboard-total-deposit"
          );

        if (res.data.success) {

          setTotalDeposit(
            res.data.total_deposit
          );

        }

      } catch (error) {

        console.log(error);

      }

    };

  // =========================
  // RECENT TRADES
  // =========================

  const fetchRecentTrades =
    async () => {

      try {

        const res =
          await axios.get(
            "https://api.statixtrading.in/api/dashboard-today-recent-trades"
          );

        if (res.data.success) {

          setRecentTrades(
            res.data.data
          );

        }

      } catch (error) {

        console.log(error);

      }

    };

  // =========================
  // USE EFFECT
  // =========================

  useEffect(() => {

    fetchTotalUsers();

    fetchActiveTrades();

    fetchCloseTrades();

    fetchTodayProfit();

    fetchTotalDeposit();

    fetchRecentTrades();

  }, []);

  return (

    <div style={styles.container}>

      <h1 style={styles.heading}>
        Dashboard
      </h1>

      {/* ========================= */}
      {/* DASHBOARD CARDS */}
      {/* ========================= */}

      <div style={styles.cardContainer}>

        {/* TOTAL USERS */}

        <div style={styles.card}>

          <div style={styles.iconBox}>
            <FaUsers size={30} />
          </div>

          <div>

            <h3 style={styles.title}>
              Total Users
            </h3>

            <h2 style={styles.value}>
              {totalUsers}
            </h2>

          </div>

        </div>

        {/* ACTIVE TRADES */}

        <div style={styles.card}>

          <div style={styles.iconBox}>
            <FaExchangeAlt size={30} />
          </div>

          <div>

            <h3 style={styles.title}>
              Active Trades
            </h3>

            <h2 style={styles.value}>
              {activeTrades}
            </h2>

          </div>

        </div>

        {/* CLOSED TRADES */}

        <div style={styles.card}>

          <div style={styles.iconBox}>
            <FaCheckCircle size={30} />
          </div>

          <div>

            <h3 style={styles.title}>
              Closed Trades
            </h3>

            <h2 style={styles.value}>
              {closeTrades}
            </h2>

          </div>

        </div>

        {/* TODAY PROFIT */}

        <div style={styles.card}>

          <div style={styles.iconBox}>
            <FaChartLine size={30} />
          </div>

          <div>

            <h3 style={styles.title}>
              Profit Today
            </h3>

            <h2 style={styles.value}>
              ₹ {todayProfit}
            </h2>

          </div>

        </div>

        {/* TOTAL DEPOSIT */}

        <div style={styles.card}>

          <div style={styles.iconBox}>
            <FaWallet size={30} />
          </div>

          <div>

            <h3 style={styles.title}>
              Total Deposit
            </h3>

            <h2 style={styles.value}>
              ₹ {totalDeposit}
            </h2>

          </div>

        </div>

      </div>


      <div style={styles.tableBox}>

        <h2 style={styles.tableHeading}>
          Today's Recent Trades
        </h2>

        <div style={styles.tableWrapper}>

          <table style={styles.table}>

            <thead>

              <tr>

                <th style={styles.th}>
                  ID
                </th>

                <th style={styles.th}>
                  Index
                </th>

                <th style={styles.th}>
                  Status
                </th>

                <th style={styles.th}>
                  P/L
                </th>

                <th style={styles.th}>
                  Amount
                </th>

                <th style={styles.th}>
                  Wallet
                </th>

              </tr>

            </thead>

            <tbody>

              {recentTrades.length > 0 ? (

                recentTrades.map((item) => (

                  <tr key={item.id}>

                    <td style={styles.td}>
                      {item.id}
                    </td>

                    <td style={styles.td}>
                      {item.index_name}
                    </td>

                    <td style={styles.td}>
                      {item.trade_status}
                    </td>

                    <td
                      style={{
                        ...styles.td,
                        color:
                          item.pl_type ===
                          "Profit"
                            ? "green"
                            : "red"
                      }}
                    >
                      {item.pl_type}
                    </td>

                    <td style={styles.td}>
                      ₹ {item.pl_amount}
                    </td>

                    <td style={styles.td}>
                      ₹ {item.max_wallet}
                    </td>

                  </tr>

                ))

              ) : (

                <tr>

                  <td
                    colSpan="6"
                    style={styles.noData}
                  >
                    No Trades Found
                  </td>

                </tr>

              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

};

const styles = {

  container: {
    padding: "20px",
    minHeight: "100vh",
    background: "#f5f6fa",
  },

  heading: {
    display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginBottom: "20px",
  color: "#1e293b",
  fontWeight: "700",
  fontSize: "30px",

  },

  cardContainer: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
  },

  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    boxShadow:
      "0 2px 10px rgba(0,0,0,0.1)",
  },

  iconBox: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#ebf2f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#333",
  },

  title: {
    margin: 0,
    fontSize: "16px",
    color: "#555",
  },

  value: {
    margin: "5px 0 0",
    color: "#111",
    fontSize: "24px",
    fontWeight: "700",
  },

  tableBox: {
    marginTop: "30px",
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow:
      "0 2px 10px rgba(0,0,0,0.1)",
  },

  tableHeading: {
    marginBottom: "15px",
    color: "#333",
  },

  tableWrapper: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    background: "#ebf2f8",
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },

  td: {
    padding: "12px",
    borderBottom:
      "1px solid #eee",
    fontSize: "14px",
  },

  noData: {
    textAlign: "center",
    padding: "20px",
  },

};

export default Dashboard;